import { PANDERR_TOKENS } from "./tokens";

export function createPanderrBaseCss(): string {
  const t = PANDERR_TOKENS;

  return `
    :root {
      --panderr-color-text: ${t.colors.text};
      --panderr-color-text-muted: ${t.colors.textMuted};
      --panderr-color-background: ${t.colors.background};
      --panderr-color-surface: ${t.colors.surface};
      --panderr-color-surface-alt: ${t.colors.surfaceAlt};
      --panderr-color-border: ${t.colors.border};

      --panderr-color-primary: ${t.colors.primary};
      --panderr-color-secondary: ${t.colors.secondary};

      --panderr-color-cta: ${t.colors.cta};
      --panderr-color-cta-hover: ${t.colors.ctaHover};
      --panderr-color-cta-text: ${t.colors.ctaText};

      --panderr-font-heading: ${t.typography.headingFont};
      --panderr-font-body: ${t.typography.bodyFont};

      --panderr-display-size: ${t.typography.display};
      --panderr-h1-size: ${t.typography.h1};
      --panderr-h2-size: ${t.typography.h2};
      --panderr-h3-size: ${t.typography.h3};

      --panderr-radius-small: ${t.radius.small};
      --panderr-radius-medium: ${t.radius.medium};
      --panderr-radius-large: ${t.radius.large};
      --panderr-radius-pill: ${t.radius.pill};

      --panderr-shadow-subtle: ${t.shadow.subtle};
      --panderr-shadow-card: ${t.shadow.card};
      --panderr-shadow-elevated: ${t.shadow.elevated};

      --panderr-max-width: ${t.layout.maxWidth};
      --panderr-wide-max-width: ${t.layout.wideMaxWidth};
      --panderr-content-width: ${t.layout.contentWidth};
      --panderr-gutter: ${t.layout.gutter};
      --panderr-section-padding: ${t.layout.sectionPadding};

      --panderr-transition-fast: ${t.motion.fast};
      --panderr-transition-normal: ${t.motion.normal};
    }

    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    html {
      scroll-behavior: smooth;
    }

    body {
      margin: 0;
      font-family: var(--panderr-font-body);
      color: var(--panderr-color-text);
      background: var(--panderr-color-background);
      font-size: ${t.typography.body};
      line-height: ${t.typography.lineHeightBody};
      -webkit-font-smoothing: antialiased;
    }

    img {
      display: block;
      max-width: 100%;
      height: auto;
    }

    a {
      color: inherit;
      text-decoration: none;
    }

    button,
    input,
    textarea,
    select {
      font: inherit;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0;
      font-family: var(--panderr-font-heading);
      line-height: ${t.typography.lineHeightHeading};
      letter-spacing: -0.03em;
      color: var(--panderr-color-text);
    }

    h1 {
      font-size: var(--panderr-h1-size);
    }

    h2 {
      font-size: var(--panderr-h2-size);
    }

    h3 {
      font-size: var(--panderr-h3-size);
    }

    p {
      margin: 0;
    }

    .panderr-shell {
      width: min(
        calc(100% - (var(--panderr-gutter) * 2)),
        var(--panderr-max-width)
      );
      margin-inline: auto;
    }

    .panderr-shell-wide {
      width: min(
        calc(100% - (var(--panderr-gutter) * 2)),
        var(--panderr-wide-max-width)
      );
      margin-inline: auto;
    }

    .panderr-section {
      padding-block: var(--panderr-section-padding);
    }

    .panderr-eyebrow {
      margin-bottom: 1rem;
      font-size: 0.8rem;
      font-weight: 800;
      letter-spacing: 0.14em;
      text-transform: uppercase;
      color: var(--panderr-color-secondary);
    }

    .panderr-lead {
      max-width: var(--panderr-content-width);
      font-size: ${t.typography.bodyLarge};
      color: var(--panderr-color-text-muted);
    }

    .panderr-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 48px;
      padding: 0.8rem 1.35rem;
      border: 1px solid transparent;
      border-radius: var(--panderr-radius-small);
      font-weight: 700;
      line-height: 1;
      cursor: pointer;
      transition:
        background var(--panderr-transition-fast),
        border-color var(--panderr-transition-fast),
        transform var(--panderr-transition-fast);
    }

    .panderr-button:hover {
      transform: translateY(-1px);
    }

    .panderr-button-primary {
      background: var(--panderr-color-cta);
      color: var(--panderr-color-cta-text);
    }

    .panderr-button-primary:hover {
      background: var(--panderr-color-cta-hover);
    }

    .panderr-button-secondary {
      border-color: var(--panderr-color-border);
      background: transparent;
      color: var(--panderr-color-text);
    }

    .panderr-card {
      border: 1px solid var(--panderr-color-border);
      border-radius: var(--panderr-radius-medium);
      background: var(--panderr-color-background);
      box-shadow: var(--panderr-shadow-subtle);
      overflow: hidden;
    }

    .panderr-image {
      width: 100%;
      object-fit: cover;
    }

    .panderr-image-hero {
      aspect-ratio: ${t.image.heroAspectRatio};
    }

    .panderr-image-card {
      aspect-ratio: ${t.image.cardAspectRatio};
    }

    @media (max-width: 768px) {
      .panderr-section {
        padding-block: 4rem;
      }

      .panderr-button {
        min-height: 46px;
      }
    }
  `;
}
